/** Human-readable page range for flip-book UI (spread vs single leaf). */
export function getBookletVisibleRange(
  pageIndex: number,
  totalPages: number,
  orientation: 'portrait' | 'landscape',
): { start: number; end: number } {
  const page = pageIndex + 1

  if (orientation === 'portrait' || totalPages <= 1) {
    return { start: page, end: page }
  }

  // Landscape: open spread — index is the left leaf (even indices after cover).
  if (pageIndex === 0 || pageIndex >= totalPages - 1) {
    return { start: page, end: page }
  }

  return { start: page, end: Math.min(page + 1, totalPages) }
}

export function formatBookletPageLabel(range: { start: number; end: number }, totalPages: number): string {
  if (range.start === range.end) {
    return `Page ${range.start} of ${totalPages}`
  }
  return `Pages ${range.start}–${range.end} of ${totalPages}`
}
